export const Types = {
  REQUEST: '@categorias/REQUEST',
  SUCCESS: '@categorias/SUCCESS',
  FAILURE: '@categorias/FAILURE',
};

export function loadCategoriasRequest() {
  return {
    type: Types.REQUEST,
  };
}

export function loadCategoriasSuccess(categorias) {
  return {
    type: Types.SUCCESS,
    payload: categorias,
  };
}

export function loadCategoriasFailure() {
  return {
    type: Types.FAILURE,
  };
}
